import { IDate } from "@modules/+new/core/device-redirection-guard/entities/date.model";

export interface Device {
	readonly blocked: boolean;
	readonly browser: string;
	readonly deviceToken: string;
	readonly isApp: boolean;
	readonly appVersion: number;
	readonly lastSeen: IDate;
	readonly os: string;
	readonly id: string;
}

export interface DeviceApiModel {
	readonly id: string;
	readonly last_seen: IDate;
	readonly os: string;
	readonly is_app: boolean;
	readonly app_version: string;
	readonly type: string;
	readonly blocked: boolean;
	readonly browser: string;
	readonly device_token: string;
}

export class DeviceAdapter {
	public static adapt(model: DeviceApiModel): Device {
		return {
			blocked: model.blocked,
			browser: model.browser,
			deviceToken: model.device_token,
			isApp: model.is_app,
			appVersion: Number.parseFloat(model.app_version),
			lastSeen: model.last_seen,
			os: model.os,
			id: model.id
		};
	}

	public static adaptMany(models: DeviceApiModel[]): Device[] {
		return models.map((model: DeviceApiModel) => DeviceAdapter.adapt(model));
	}
}
